// @Version: 1.0.0
export enum ANDOROPTION {
   OR = "OR",
   XOR = "XOR",
   AND = "AND",
   XAND = "XAND"
}